.responsive-logo {
  min-width: 30px;

  &__image {
    height: 15px;
    width: auto;
    margin-left: 20px;
    max-width: 150px;

    &--softphone,
    &--small {
      height: 30px;
      width: auto;
    }

    &--softphone {
      margin-left: -5px;
    }
  }
}
